module.exports = __webpack_public_path__ + "img/banner02.a21a54f9.png";